import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    transition: '0.3s',
    width: '100%',
  },
  interactive: {
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.action.hover,
    },
  },
  bannerContainer: {
    position: 'relative',
    width: '100%',
    height: '110px',
    overflow: 'hidden',
  },
  banner: {
    objectFit: 'cover',
  },
  vendorName: {
    padding: theme.spacing(1, 0, 1, 2),
  },
}));
